import React from 'react';
import useStyles from '@components/Sura/Footer/style';
import useStore from '@hooks/useStore';
import { Typography } from '@material-ui/core';
import { ILinkComponent } from '@components/Sura/Footer/types';

const LinkComponent: React.FC<ILinkComponent> = ({ URL, title, notice = false }) => {
  const { ui } = useStore();
  const css = useStyles({ isMobile: ui.isMobileScreen });
  return (
    <>
      {URL !== '' ? (
        <a target="_blank" rel="noreferrer noopener" href={URL} className={css.link}>
          <Typography className={notice ? css.labelBlue : css.subTitle}>{title}</Typography>
        </a>
      ) : (
        <Typography className={notice ? css.labelBlue : css.subTitle}>{title}</Typography>
      )}
    </>
  );
};

export default LinkComponent;
